import styled from 'styled-components';

const ShareLink = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
`;

export { ShareLink };
